import React, {useEffect, useState} from "react";
import {FlatList, View, Text} from "react-native";
import {ModalView} from "../ModalView";
import {v4 as uuidv4} from 'uuid';
import {CustomButton} from "../CustomButton";
import {getTrimmedFileName} from "../../helper";

interface IFileUploadComponentProps {
    onUploadFiles: (any) => void;
    show: boolean;
    onClose: () => void;
    headerContent: JSX.Element;
}

const FileUploadComponent = (props: IFileUploadComponentProps) => {
    const {show, onUploadFiles, onClose, headerContent} = props;
    const [imageArray, setImageArray] = useState(new Map());

    useEffect(() => {
        setImageArray(new Map());
    },[show]);

    const validateFiles = (fileArray) => {
        const validFileNameLength = 75;

        fileArray.forEach(file => {
            if (file.name.length > validFileNameLength) {
                throw  Error("Please upload files having less than\ " +
                       "75 characters in their file name.");
            }
        });
    }
    return (
        <ModalView show={show} onClose={() => onClose()}
                   size={"small"}
                   headerContent={headerContent}
        >
            <View style={{padding: 10, flex: 1}}>
                <FlatList data={Array.from(imageArray.values())}
                          horizontal={true}
                          renderItem={({item, index}) => {
                              return item.type.includes("image") ?
                                  <View style={{width: 150, height: 150, marginHorizontal: 5}}>
                                      <img src={item.localPath} style={{
                                          opacity: item.isActive ? 1 : 0.5,
                                          width: '100%', height: 130
                                      }}  alt={"File"}/>
                                      <Text style={{width: '100%', marginVertical: 2, textAlign: "center"}}>
                                          {getTrimmedFileName(item.name)}
                                      </Text>
                                  </View> :
                                  <View style={{width: 150, height: 150, marginHorizontal: 5}}>
                                      <img src={require('../../../assets/file.png')} style={{
                                          opacity: item.isActive ? 1 : 0.5,
                                          width: '100%', height: 150
                                      }}  alt={"File"}/>
                                      <Text style={{width: '100%', marginVertical: 2, textAlign: "center"}}>
                                          {item.name.length > 10 ?
                                              item.name.substring(0, 4) + "..." + item.name.substring(item.name.length - 5) :
                                              item.name
                                          }
                                      </Text>
                                  </View>
                }}/>
                <View style={{alignSelf: 'flex-end', flexDirection: 'row'}}>
                    <input type="file"
                           multiple={true}
                           accept="*"
                           onChange={(event) => {
                               const fileArray = Array.from(event.target.files);
                               try {
                                   validateFiles(fileArray);
                               }
                               catch (err) {
                                   event.target.files = null;
                                   event.target.value = "";
                                   alert(err);
                                   return;
                               }
                               setImageArray(prevState => {
                                   const newState = new Map(prevState);
                                   fileArray.forEach(file => {
                                       const id = uuidv4();
                                       const localPath = URL.createObjectURL(file);
                                       Object.assign(file, {
                                           id,
                                           localPath: localPath,
                                           isActive: true,
                                       });
                                       newState.set(id, file);
                                   });
                                   return newState;
                               });
                           }}
                    />
                    <CustomButton text={'Upload'}
                                  disabled={Array.from(imageArray.values()).length === 0}
                                  onPress={() => onUploadFiles(Array.from(imageArray.values()))}/>
                </View>
            </View>
        </ModalView>
    )
};


export default FileUploadComponent;
